import axiosInstance from "../../services/axiosInstance";
import * as Endpoints from "../../entities/Endpoints";

// Fetch Leads with Pagination and Sorting
export const fetchLeadsApi = async ({
  coachId,
  pageNumber = 1,
  pageSize = 10,
  sortOrder = "desc",
}) => {
  const params = {
    PageNumber: pageNumber,
    PageSize: pageSize,
    sortOrder,
  };
  const response = await axiosInstance.get(
    `${Endpoints.GET_ALL_LEAD}/${coachId}`,
    {
      params,
    }
  );
  return response.data;
};

export const filterLeadsApi = async ({
  coachId,
  name = "",
  status = "",
  pageNumber = 1,
  pageSize = 10,
  sortOrder = "desc",
}) => {
  const params = {
    PageNumber: pageNumber,
    PageSize: pageSize,
    sortOrder,
    name: name || undefined,
    status: status || undefined,
  };

  const response = await axiosInstance.get(
    `${Endpoints.FILTER_LEADS}/${coachId}`,
    { params }
  );

  return {
    leads: response.data.leads,
    totalCount: response.data.totalCount,
  };
};

export const postMultipleLeadsApi = async (coachId, leads) => {
  const response = await axiosInstance.post(
    `${Endpoints.POST_MULTIPLE_LEADS}/${coachId}`,
    leads
  );
  return response.data;
};

export const updateLeadApi = async (leadId, leadData) => {
  const response = await axiosInstance.post(
    `${Endpoints.UPDATE_LEAD}/${leadId}`,
    leadData
  );
  return response.data;
};

// Add Offer
export const addOfferApi = async (offerData) => {
  const response = await axiosInstance.post(Endpoints.ADD_OFFER, offerData);
  return response.data;
};

export const deleteLeadsApi = async (leadIds) => {
  const response = await axiosInstance.post(Endpoints.DELETE_LEADS, leadIds);
  return response.data;
};

export const updateLeadStatusApi = async (coachId, leadId, status) => {
  const response = await axiosInstance.patch(
    `${Endpoints.UPDATE_LEAD_STATUS}/${coachId}/${leadId}/${status}`
  );
  return response.data;
};

export const sendOfferApi = async (coachId, offerData) => {
  const response = await axiosInstance.post(
    `${Endpoints.SEND_OFFER}/${coachId}`,
    offerData
  );
  return response.data;
};

export const createFreeClientOfferApi = async (coachId, payload) => {
  const response = await axiosInstance.post(
    `${Endpoints.CREATE_FREE_CLIENT_OFFER}/${coachId}`,
    payload
  );
  return response.data;
};
